import { render } from "./StarRating.vue?vue&type=template&id=73223d0a&scoped=true&ts=true"
import script from "./StarRating.vue?vue&type=script&lang=ts"
export * from "./StarRating.vue?vue&type=script&lang=ts"

import "./StarRating.vue?vue&type=style&index=0&id=73223d0a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73223d0a"]])

export default __exports__